
import { useState, useRef } from "react";
import { Formik, Form } from "formik";
import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
import axios from "axios";
import * as Yup from "yup";
import { ProfileAvatar, DropAndDragIcon, GoodToastIcon, CloseToastIcon } from "../../../components/common/IconComponents";
import Toast from "./Toast"; // Import the Toast component

const MyProfileTab = () => {
    const [dragActive, setDragActive] = useState(false);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [profileAvatar, setProfileAvatar] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const inputRef = useRef(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFile(e.dataTransfer.files);
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            handleFile(e.target.files);
        }
    };

    const initialValues = {
        firstName: "",
        lastName: "",
        email: "idowu.oluwatofunmi9@gmail.com",
        role: "",
    };

    const dropDownOptions = [
        { key: "Select", value: "" },
        { key: "Admin", value: "option1" },
        { key: "Analyst", value: "option2" },
    ];

    // validation
    const validationSchema = Yup.object({
        firstName: Yup.string(),
        lastName: Yup.string(),
        email: Yup.string(),
        role: Yup.string(),
    });

    // Toast state and toggle function
    const toggleToast = () => {
        setShowToast(!showToast);
    };

    const handleFile = (files) => {
        const file = files[0];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "eqprvodt");

        axios
            .post("https://api.cloudinary.com/v1_1/darnus3nl/image/upload", formData)
            .then((response) => {
                const imageUrl = response.data.secure_url;
                setUploadedImage(imageUrl);
            })
            .catch((error) => {
                console.error("Error uploading image to Cloudinary: ", error);
            });
    };

    // Form submission
    const onSubmit = (values, { resetForm }) => {
        console.log("Form data", values);
        setIsFormSubmitted(true);
        setProfileAvatar(uploadedImage);
        toggleToast();
        resetForm();
    };

    const handleToastClose = () => {
        setShowToast(false);
        setDragActive(false);
        setUploadedImage(null);
        setIsFormSubmitted(false);
    };

    return (
        <section>
            <div className="md:px-4">
                {/* Toast */}
                {showToast && (
                    <Toast
                        message="Your profile photo has been successfully updated"
                        successIcon={<GoodToastIcon className="w-4 h-4 lg:w-8 lg:h-8" />}
                        closeIcon={<CloseToastIcon />}
                        onClose={handleToastClose}
                    />
                )}

                <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
                    <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">My Profile</h1>
                </nav>

                <div className="flex flex-col md:flex-row gap-8 mt-4 md:mt-24 mb-4">
                    <span className="">
                        {profileAvatar ? (
                            <img src={profileAvatar} alt="Profile Avatar" className="rounded-full h-16 w-16" />
                        ) : (
                            <ProfileAvatar className="rounded-full h-16 w-16" />
                        )}
                    </span>

                    <div
                        id="drag-drop-area"
                        className={`flex items-center justify-center h-full border rounded bg-th-bg text-center p-4 ${dragActive ? "bg-white" : ""}`}
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onDrop={handleDrop}
                    >
                        {uploadedImage ? (
                            <img src={uploadedImage} alt="Uploaded" className="max-h-64 max-w-full" />
                        ) : (
                            <div>
                                <button
                                    className="cursor-pointer border-none p-0.5 bg-transparent"
                                    onClick={() => inputRef.current.click()}
                                >
                                    <DropAndDragIcon className="mb-1" />
                                </button>
                                <p className="mb-1 text-base font-normal">
                                    <span className="text-enabled-btn">Click to upload</span> or drag and drop
                                </p>
                                <p className="text-success-email text-sm font-normal">SVG, PNG, or JPG (max. 800x400px)</p>
                            </div>
                        )}
                    </div>
                    <input
                        ref={inputRef}
                        type="file"
                        id="input-file-upload"
                        multiple={false}
                        onChange={handleChange}
                        className="hidden"
                    />
                </div>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {(formik) => {
                        return (
                            <Form className="">
                                <FormikControl
                                    control="input"
                                    label="First name"
                                    type="text"
                                    placeholder="Shakirat"
                                    name="firstName"
                                    className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
                                />

                                <FormikControl
                                    control="input"
                                    label="Last name"
                                    type="text"
                                    placeholder="Akanji"
                                    name="lastName"
                                    className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
                                />

                                <FormikControl
                                    control="input"
                                    label="Email address"
                                    type="email"
                                    placeholder="idowu.oluwatofunmi9@gmail.com"
                                    name="email"
                                    disabled={true}
                                    className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
                                />

                                <FormikControl
                                    control="select"
                                    label="Role"
                                    type="text"
                                    name="role"
                                    options={dropDownOptions}
                                    className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
                                />

                                <button
                                    type="submit"
                                    className={`${isFormSubmitted ? "bg-gray-300 cursor-not-allowed" : "bg-enabled-btn"
                                        } text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20`}
                                    disabled={!formik.isValid || isFormSubmitted}
                                >
                                    {isFormSubmitted ? "Save" : "Save"}
                                </button>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </section>
    );
};

export default MyProfileTab;



// Okay with external toast - but toast not reusable
// import React, { useState } from "react";
// // import { useNavigate } from "react-router-dom";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import { ProfileAvatar, DropAndDragIcon } from "../../../components/common/IconComponents";
// import Toast from "./Toast"; // Import the Toast component

// const MyProfileTab = () => {
//     // const navigate = useNavigate();

//     const initialValues = {
//         firstName: "",
//         lastName: "",
//         email: "idowu.oluwatofunmi9@gmail.com",
//         role: "",
//     };

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "option1" },
//         { key: "Analyst", value: "option2" },
//     ];

//     // validation
//     const validationSchema = Yup.object({
//         firstName: Yup.string().required("Required"),
//         lastName: Yup.string().required("Required"),
//         email: Yup.string(),
//         role: Yup.string().required("Required"),
//     });

//     // Toast state and toggle function
//     const [showToast, setShowToast] = useState(false);

//     const toggleToast = () => {
//         setShowToast(!showToast);
//     };

//     // Form submission
//     const onSubmit = (values) => {
//         console.log("Form data", values);
//         toggleToast(); // Show the toast
//     };

//     return (
//         <section>
//             <div className="md:px-4">
//                 {/* Toast */}
//                 {showToast && <Toast onClose={toggleToast} />}

//                 <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-xl md:text-[28px] font-medium">My Profile</h1>
//                 </nav>

//                 <div className="flex gap-8 mt-4 mb-4">
//                     <span className="">
//                         <ProfileAvatar />
//                     </span>

//                     <div className="flex flex-col items-center bg-chat-gray-bg p-4">
//                         <DropAndDragIcon className="mb-1" />
//                         <p className="mb-1 text-base font-normal">
//                             <span className="text-enabled-btn">Click to upload</span> or drag and drop
//                         </p>
//                         <p className="text-success-email text-sm font-normal">SVG, PNG, or JPG (max. 800x400px)</p>
//                     </div>
//                 </div>

//                 <Formik
//                     initialValues={initialValues}
//                     validationSchema={validationSchema}
//                     onSubmit={onSubmit}
//                 >
//                     {(formik) => {
//                         return (
//                             <Form className="">
//                                 <FormikControl
//                                     control="input"
//                                     label="First name"
//                                     type="text"
//                                     placeholder="Shakirat"
//                                     name="firstName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Last name"
//                                     type="text"
//                                     placeholder="Akanji"
//                                     name="lastName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Email address"
//                                     type="email"
//                                     placeholder="idowu.oluwatofunmi9@gmail.com"
//                                     name="email"
//                                     disabled={true}
//                                     className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
//                                 />

//                                 <FormikControl
//                                     control="select"
//                                     label="Role"
//                                     type="text"
//                                     name="role"
//                                     options={dropDownOptions}
//                                 />

//                                 <button
//                                     type="submit"
//                                     className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                                     disabled={!formik.isValid}
//                                 >
//                                     Save
//                                 </button>
//                             </Form>
//                         );
//                     }}
//                 </Formik>
//             </div>
//         </section>
//     );
// };

// export default MyProfileTab;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import { CloseToastIcon, DropAndDragIcon, GoodToastIcon, ProfileAvatar } from "../../../components/common/IconComponents";

// const MyProfileTab = () => {
//     const navigate = useNavigate();

//     const initialValues = {
//         firstName: "",
//         lastName: "",
//         email: "idowu.oluwatofunmi9@gmail.com",
//         role: "",
//     };

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "option1" },
//         { key: "Analyst", value: "option2" },
//     ];

//     // validation
//     const validationSchema = Yup.object({
//         firstName: Yup.string().required("Required"),
//         lastName: Yup.string().required("Required"),
//         email: Yup.string(),
//         role: Yup.string().required("Required"),
//     });

//     // Toast state and toggle function
//     const [showToast, setShowToast] = useState(false);

//     const toggleToast = () => {
//         setShowToast(!showToast);
//     };

//     // Form submission
//     const onSubmit = (values) => {
//         console.log("Form data", values);
//         toggleToast(); // Show the toast
//         setTimeout(() => {
//             navigate("/"); // Navigate to the home page after a delay
//         }, 2000);
//     };

//     return (
//         <section>
//             <div className="md:px-4">
//                 {/* Toast */}
//                 {showToast && (
//                     <div
//                         id="toast-success"
//                         className="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border"
//                         role="alert"
//                     >
//                         <div className="inline-flex items-center justify-center flex-shrink-0">
//                             <GoodToastIcon />
//                         </div>
//                         <div className="ml-3 text-xs md:text-sm font-normal">
//                             Your Profile Photo has been successfully updated
//                         </div>
//                         <button
//                             type="button"
//                             className="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500"
//                             data-dismiss-target="#toast-success"
//                             aria-label="Close"
//                             onClick={toggleToast} // Hide the toast when the close button is clicked
//                         >
//                             <CloseToastIcon />
//                         </button>
//                     </div>
//                 )}

//                 <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-xl md:text-[28px] font-medium">My Profile</h1>
//                 </nav>

//                 <div className="flex gap-8 mt-4 mb-4">
//                     <span className="">
//                         <ProfileAvatar />
//                     </span>

//                     <div className="flex flex-col items-center bg-chat-gray-bg p-4">
//                         <DropAndDragIcon className="mb-1" />
//                         <p className="mb-1 text-base font-normal">
//                             <span className="text-enabled-btn">Click to upload</span> or drag and drop
//                         </p>
//                         <p className="text-success-email text-sm font-normal">SVG, PNG, or JPG (max. 800x400px)</p>
//                     </div>
//                 </div>

//                 <Formik
//                     initialValues={initialValues}
//                     validationSchema={validationSchema}
//                     onSubmit={onSubmit}
//                 >
//                     {(formik) => {
//                         return (
//                             <Form className="">
//                                 <FormikControl
//                                     control="input"
//                                     label="First name"
//                                     type="text"
//                                     placeholder="Shakirat"
//                                     name="firstName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Last name"
//                                     type="text"
//                                     placeholder="Akanji"
//                                     name="lastName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Email address"
//                                     type="email"
//                                     placeholder="idowu.oluwatofunmi9@gmail.com"
//                                     name="email"
//                                     disabled={true}
//                                     className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
//                                 />

//                                 <FormikControl
//                                     control="select"
//                                     label="Role"
//                                     type="text"
//                                     name="role"
//                                     options={dropDownOptions}
//                                 />

//                                 <button
//                                     type="submit"
//                                     className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                                     disabled={!formik.isValid}
//                                     onClick={(event) => {
//                                         event.preventDefault(); // Prevent form submission
//                                         if (formik.isValid) {
//                                             toggleToast(); // Show the toast when the save button is clicked and all fields are valid
//                                             formik.submitForm(); // Manually trigger form submission
//                                         }
//                                     }}
//                                 >
//                                     Save
//                                 </button>
//                             </Form>
//                         );
//                     }}
//                 </Formik>
//             </div>
//         </section>
//     );
// };

// export default MyProfileTab;



// TAKES TO HOME PAGE
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import { CloseToastIcon, DropAndDragIcon, GoodToastIcon, ProfileAvatar } from "../../../components/common/IconComponents";

// const MyProfileTab = () => {
//     const navigate = useNavigate();

//     const initialValues = {
//         firstName: "",
//         lastName: "",
//         email: "idowu.oluwatofunmi9@gmail.com",
//         role: "",
//     };

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "option1" },
//         { key: "Analyst", value: "option2" },
//     ];

//     // validation
//     const validationSchema = Yup.object({
//         firstName: Yup.string().required("Required"),
//         lastName: Yup.string().required("Required"),
//         email: Yup.string(),
//         role: Yup.string().required("Required"),
//     });

//     // Toast state and toggle function
//     const [showToast, setShowToast] = useState(false);

//     const toggleToast = () => {
//         setShowToast(!showToast);
//     };

//     // Form submission
//     const onSubmit = (values) => {
//         console.log("Form data", values);
//         navigate("/");
//         toggleToast(); // Show the toast
//     };

//     return (
//         <section>
//             <div className="md:px-4">
//                 {/* Toast */}
//                 {showToast && (
//                     <div
//                         id="toast-success"
//                         className="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border"
//                         role="alert"
//                     >
//                         <div className="inline-flex items-center justify-center flex-shrink-0">
//                             <GoodToastIcon />
//                         </div>
//                         <div className="ml-3 text-xs md:text-sm font-normal">
//                             Your Profile Photo has been successfully updated
//                         </div>
//                         <button
//                             type="button"
//                             className="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500"
//                             data-dismiss-target="#toast-success"
//                             aria-label="Close"
//                             onClick={toggleToast} // Hide the toast when the close button is clicked
//                         >
//                             <CloseToastIcon />
//                         </button>
//                     </div>
//                 )}

//                 <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-xl md:text-[28px] font-medium">My Profile</h1>
//                 </nav>

//                 <div className="flex gap-8 mt-4 mb-4">
//                     <span className="">
//                         <ProfileAvatar />
//                     </span>

//                     <div className="flex flex-col items-center bg-chat-gray-bg p-4">
//                         <DropAndDragIcon className="mb-1" />
//                         <p className="mb-1 text-base font-normal">
//                             <span className="text-enabled-btn">Click to upload</span> or drag and drop
//                         </p>
//                         <p className="text-success-email text-sm font-normal">SVG, PNG, or JPG (max. 800x400px)</p>
//                     </div>
//                 </div>

//                 <Formik
//                     initialValues={initialValues}
//                     validationSchema={validationSchema}
//                     onSubmit={onSubmit}
//                 >
//                     {(formik) => {
//                         return (
//                             <Form className="">
//                                 <FormikControl
//                                     control="input"
//                                     label="First name"
//                                     type="text"
//                                     placeholder="Shakirat"
//                                     name="firstName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Last name"
//                                     type="text"
//                                     placeholder="Akanji"
//                                     name="lastName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Email address"
//                                     type="email"
//                                     placeholder="idowu.oluwatofunmi9@gmail.com"
//                                     name="email"
//                                     disabled={true}
//                                     className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
//                                 />

//                                 <FormikControl
//                                     control="select"
//                                     label="Role"
//                                     type="text"
//                                     name="role"
//                                     options={dropDownOptions}
//                                 />

//                                 <button
//                                     type="submit"
//                                     className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                                     disabled={!formik.isValid}
//                                     onClick={() => {
//                                         if (formik.isValid) {
//                                             toggleToast(); // Show the toast when the save button is clicked and all fields are valid
//                                             formik.handleSubmit();
//                                         }
//                                     }}
//                                 >
//                                     Save
//                                 </button>
//                             </Form>
//                         );
//                     }}
//                 </Formik>
//             </div>
//         </section>
//     );
// };

// export default MyProfileTab;





// SHOWS TOAST ONLY ON EMPTY FIELDS
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import { CloseToastIcon, DropAndDragIcon, GoodToastIcon, ProfileAvatar } from "../../../components/common/IconComponents";

// const MyProfileTab = () => {
//     const navigate = useNavigate();

//     const initialValues = {
//         firstName: "",
//         lastName: "",
//         role: "",
//     };

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "option1" },
//         { key: "Analyst", value: "option2" },
//     ];

//     // validation
//     const validationSchema = Yup.object({
//         firstName: Yup.string().required("Required"),
//         lastName: Yup.string().required("Required"),
//         email: Yup.string().email("Invalid email format").required("Required"),
//         role: Yup.string().required("Required"),
//     });

//     // Toast state and toggle function
//     const [showToast, setShowToast] = useState(false);

//     const toggleToast = () => {
//         setShowToast(!showToast);
//     };

//     // Form submission
//     const onSubmit = (values) => {
//         console.log("Form data", values);
//         navigate("/");
//         toggleToast(); // Show the toast
//     };

//     return (
//         <section>
//             <div className="md:px-4">
//                 {/* Toast */}
//                 {showToast && (
//                     <div
//                         id="toast-success"
//                         className="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border"
//                         role="alert"
//                     >
//                         <div className="inline-flex items-center justify-center flex-shrink-0">
//                             <GoodToastIcon />
//                         </div>
//                         <div className="ml-3 text-xs md:text-sm font-normal">
//                             Your Profile Photo has been successfully updated
//                         </div>
//                         <button
//                             type="button"
//                             className="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500"
//                             data-dismiss-target="#toast-success"
//                             aria-label="Close"
//                             onClick={toggleToast} // Hide the toast when the close button is clicked
//                         >
//                             <CloseToastIcon />
//                         </button>
//                     </div>
//                 )}

//                 <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-xl md:text-[28px] font-medium">My Profile</h1>
//                 </nav>

//                 <div className="flex gap-8 mt-4 mb-4">
//                     <span className="">
//                         <ProfileAvatar />
//                     </span>

//                     <div className="flex flex-col items-center bg-chat-gray-bg p-4">
//                         <DropAndDragIcon className="mb-1" />
//                         <p className="mb-1 text-base font-normal">
//                             <span className="text-enabled-btn">Click to upload</span> or drag and drop
//                         </p>
//                         <p className="text-success-email text-sm font-normal">
//                             SVG, PNG, or JPG (max. 800x400px)
//                         </p>
//                     </div>
//                 </div>

//                 <Formik
//                     initialValues={initialValues}
//                     validationSchema={validationSchema}
//                     onSubmit={onSubmit}
//                 >
//                     {(formik) => {
//                         return (
//                             <Form className="">
//                                 <FormikControl
//                                     control="input"
//                                     label="First name"
//                                     type="text"
//                                     placeholder="Shakirat"
//                                     name="firstName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Last name"
//                                     type="text"
//                                     placeholder="Akanji"
//                                     name="lastName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Email address"
//                                     type="email"
//                                     placeholder="idowu.oluwatofunmi9@gmail.com"
//                                     name="email"
//                                     disabled={true}
//                                     value="idowu.oluwatofunmi9@gmail.com"
//                                     className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
//                                 />

//                                 <FormikControl
//                                     control="select"
//                                     label="Role"
//                                     type="text"
//                                     name="role"
//                                     options={dropDownOptions}
//                                 />

//                                 <button
//                                     type="submit"
//                                     className="bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                                     disabled={!formik.isValid}
//                                     onClick={() => {
//                                         if (formik.isValid) {
//                                             toggleToast(); // Show the toast when the save button is clicked and all fields are valid
//                                             formik.handleSubmit();
//                                         }
//                                     }}
//                                 >
//                                     Save
//                                 </button>
//                             </Form>
//                         );
//                     }}
//                 </Formik>
//             </div>
//         </section>
//     );
// };

// export default MyProfileTab;




// TOAST WITHOUT FUNCTIONALITY
// import { useNavigate } from "react-router-dom";
// import { Formik, Form } from "formik";
// import FormikControl from "../../../components/signUpForm/ReusableFormik/FormikControl";
// import * as Yup from "yup";
// import {  CloseToastIcon, DropAndDragIcon, GoodToastIcon, ProfileAvatar} from "../../../components/common/IconComponents";

// const MyProfileTab = () => {
//     const navigate = useNavigate();

//     const initialValues = {
//         firstName: "",
//         lastName: "",
//         role: "",
//     };

//     const dropDownOptions = [
//         { key: "Select", value: "" },
//         { key: "Admin", value: "option1" },
//         { key: "Analyst", value: "option2" },
//     ];
    
//     // validation
//     const validationSchema = Yup.object({
//         firstName: Yup.string().required("Required"),
//         lastName: Yup.string().required("Required"),
//         email: Yup.string().email("Invalid email format").required("Required"),
//         role: Yup.string().required("Required"),
//     });

//     //   Form submission
//     const onSubmit = (values) => {
//         console.log("Form data", values);
//         navigate("/");
//     };

//     return (
//         <section>
//             <div className="md:px-4">
//                 {/* Toast */}
//                 <div id="toast-success" class="flex mt-40 items-center w-full max-w-2xl p-3 text-toast-success bg-white rounded-md border border-toast-border" role="alert">
//                     <div class="inline-flex items-center justify-center flex-shrink-0">
//                         <GoodToastIcon />
//                     </div>
//                     <div class="ml-3 text-xs md:text-sm font-normal">Your Profile Photo has been successfully updated</div>
//                     <button type="button" class="ml-auto -mx-1.5 -my-1.5 rounded-md focus:ring-1 focus:ring-th-bg p-1.5 hover:bg-gray-100 inline-flex h-8 w-8 dark:text-gray-500" data-dismiss-target="#toast-success" aria-label="Close">
//                         <CloseToastIcon />
//                     </button>
//                 </div>

//                 <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-xl md:text-[28px] font-medium">My Profile</h1>
//                 </nav>

//                 <div className="flex gap-8 mt-4 mb-4">
//                     <span className="">
//                         <ProfileAvatar />
//                     </span>

//                     <div className="flex flex-col items-center bg-chat-gray-bg p-4">
//                         <DropAndDragIcon className="mb-1" />
//                         <p className="mb-1 text-base font-normal"><span className="text-enabled-btn">Click to upload</span> or drag and drop</p>
//                         <p className="text-success-email text-sm font-normal">SVG, PNG, or JPG (max. 800x400px)</p>
//                     </div>
//                 </div>

//                 <Formik
//                     initialValues={initialValues}
//                     validationSchema={validationSchema}
//                     onSubmit={onSubmit}
//                 >
//                     {(formik) => {
//                         return (
//                             <Form className="">
//                                 <FormikControl
//                                     control="input"
//                                     label="First name"
//                                     type="text"
//                                     placeholder="Shakirat"
//                                     name="firstName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Last name"
//                                     type="text"
//                                     placeholder="Akanji"
//                                     name="lastName"
//                                 />

//                                 <FormikControl
//                                     control="input"
//                                     label="Email address"
//                                     type="email"
//                                     placeholder="idowu.oluwatofunmi9@gmail.com"
//                                     name="email"
//                                     disabled={true}
//                                     value="idowu.oluwatofunmi9@gmail.com"
//                                     className="w-full px-4 py-2 pr-10 text-disabled text-xs md:text-sm border border-disabled rounded-md focus:outline-none focus:ring-2 bg-neutral-bg shadow-md"
//                                 />

//                                 <FormikControl
//                                     control="select"
//                                     label="Role"
//                                     type="text"
//                                     name="role"
//                                     options={dropDownOptions}
//                                 />

//                                 <button
//                                     type="submit"
//                                     className={
//                                         "bg-enabled-btn text-slate-50 text-base font-medium border rounded-md cursor-pointer my-8 py-2 px-20"
//                                     }
//                                     disabled={!formik.isValid}
//                                 >
//                                     Save
//                                 </button>
//                             </Form>
//                         );
//                     }}
//                 </Formik>
//             </div>
//         </section>
//     );
// }

// export default MyProfileTab